import {dict, mapItems} from 'ldash'
import {createSelector} from 'reselect'

const invert = values => dict(mapItems(values, (name, {value}) => [value, name]))
export const domainStates = createSelector(
  [root => root.meta.request.dname, root => root.config.states],
  (dname, states) => {
    return {
      states: states[dname],
      byValue: dict(mapItems(states[dname], (statusType, values) => [statusType, invert(values)])),
    }
  }
)
